export default __webpack_public_path__ + "static/hp-brand-deck-22-7f1f2861de2f2fd8bd8a742934d4853f.png";